<script setup>
import { computed, defineProps, defineEmits, ref } from "vue";
import { t } from "@/controllerLK/AvalLocalization";
// import SupportFileButton from "@/components/SupportWidget/SupportFileButton.vue";

const props = defineProps({
  form: {
    type: Object,
    required: true
  },
  isValid: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(["update:form", "submit"]);

const formModel = computed({
  get: () => props.form,
  set: (value) => emit("update:form", value)
});

const emailError = ref(false);

const handleEmailUpdate = (value) => {
  formModel.value.email = value;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  emailError.value = value && !emailRegex.test(value);
};

const handleSubmit = (event) => {
  event.preventDefault();
  if (props.isValid) {
    emit("submit");
  }
};
</script>

<template>
  <div class="support-form">
    <div class="support-form__body">
      <AvalInputPrimary
        v-model="formModel.name"
        :label="t('support_widget.input.name.label')"
        :placeholder="t('support_widget.input.name.placeholder')"
      />
      <div class="support-form__input-group">
        <AvalInputPrimary
          :model-value="formModel.email"
          type="email"
          :label="t('support_widget.input.email.label')"
          :placeholder="t('support_widget.input.email.placeholder')"
          :error="emailError"
          @update:model-value="handleEmailUpdate"
        />
        <span
          v-if="emailError"
          class="support-form__error"
        >
          Неправильный формат email адреса
        </span>
      </div>
      <AvalTextAreaPrimary
        v-model="formModel.question"
        height="220px"
        :label="t('support_widget.input.question.label')"
        :placeholder="t('support_widget.input.question.placeholder')"
      />
      <!-- <SupportFileButton v-model:file="formModel.file" /> 
       // Задача 2166 - прикрепление файла скрываем, пока в API не появится.  
       // TextAreа выше увеличена (170px -> 220px) на это время.
       --> 
    </div>

    <div class="support-form__footer">
      <AvalButtonAccentPrimary
        type="submit"
        size="large"
        :disabled="!isValid"
        class="support-form__button"
        @click="handleSubmit"
      >
        {{ t('support_widget.button.submit') }}
      </AvalButtonAccentPrimary>
    </div>
  </div>
</template>

<style scoped lang="scss">
.support-form {
  display: flex;
  flex-direction: column;
  flex: 1;

  &__body {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 14px;
    flex: 1;
  }

  &__footer {
    padding: 10px 14px;
    border-top: 1px solid var(--border-bd-divider);
  }

  &__input-group {
    display: flex;
    flex-direction: column;
  }

  &__error {
    color: #DA1E28;
    font-size: 12px;
    margin-top: 8px;
  }

  &__button {
    width: 100%;
  }
}
</style>